import { COVERGO_SAAS_DEV } from "../consts.js"

export const prudential_dev = {
	"prudential-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "prudential_dev",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_DEV,
		fileSystem: {
			bucketName: "covergo-apse1-dev-prudential-dev"
		}
	}
}
